const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.35291 59.95472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.65132,27.32691l1.265-.73m8.829-5.097,1.265-.73m-11.359,0,1.265.73m8.829,5.097,1.265.73m-2.401,2.4-.73-1.264m-5.097-8.829-.73-1.26495m0,11.358.73-1.264m5.097-8.829.73-1.26495m-9.836,5.679h1.46m10.195,0h1.46m-6.558,6.558v-1.46m0-10.195v-1.46m5.078,6.538a5.0775,5.0775,0,1,1-5.078-5.078A5.078,5.078,0,0,1,37.40832,24.02887Zm-5.077,1.184a1.189,1.189,0,1,1,1.188-1.189A1.18989,1.18989,0,0,1,32.33132,25.21289Zm-16.732,8.258h33.442m-2.365-19.627h-28.719a2.32635,2.32635,0,0,0-2.36,2.327v19.588a2.33323,2.33323,0,0,0,2.36,2.336h28.719a2.33626,2.33626,0,0,0,2.365-2.336V16.1709A2.32938,2.32938,0,0,0,46.67631,13.84387Zm-19.91,27.712-.726,5.11005a.70188.70188,0,0,0,.726.676h11.157a.70251.70251,0,0,0,.726-.676l-.728-5.11005",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompu);
export default __webpack_public_path__ + "static/media/compu.610e828fb653aea62239c38bc65ff33d.svg";
export { ForwardRef as ReactComponent };